
<form id="addPolicyForm" (ngSubmit)="addPolicy()" [formGroup]="addPolicyForm">
    <div class="row">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Select a category:
        </div>
        <div class="col-sm-3">
            <select id="selectedCategoryID_New" formControlName = "selectedCategoryID_New" (change)="enableFileButton()">
                <option value="0">Select a category</option>
                <option *ngFor="let category of categoryList_New" value="{{category.categoryID}}">{{category.description}}</option>
            </select>
            <input type="text" formControlName="PNumber" hidden>
        </div>
    </div><br>
    <div class="row" style="border:none;">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Title:</div>
        <div class="col-sm-3"><input id="title_New" type="text" formControlName = "title_New" (keyup)="enableFileButton()"/></div>
    </div><br>
    <div class="row">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Enter Policy Numbrt:</div>
        <div class="col-sm-3"><input id="policyNumber_New" type="text" formControlName = "policyNumber_New" (keyup)="enableFileButton()"/></div>
    </div><br>
    <div class="row">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Enter Former Policy Numbrt (Optional):</div>
        <div class="col-sm-3"><input id="policyNumberFormer_New" type="text" formControlName = "policyNumberFormer_New" /></div>
    </div><br>
    <div class="row">
        <div class="col-sm-3" style="text-align: right; font-weight: bold;">Choose the File:</div>
        <div class="col-sm-3">
            <input id="file_New" type="file" class="file-input" formControlName="file_New" (change)="upload($event)" #fileUpload disabled/>
            <!-- <button id="file_New_btn" style="display:block;width:120px; height:30px;" onclick="document.getElementById('file_New').click()" disabled>Choose File</button> -->
        </div>
        <div class="col-md-3">
            <span class="upload" *ngIf="progress > 0">
              {{progress}}%
            </span>
            <span class="upload" ngModel="messages" style="color: red;">
              {{messages}}
            </span>
        </div>
        <!-- <div class="file-upload">
            {{fileName || "No file yet."}}
         
             <button mat-mini-fab color="primary" class="upload-btn"
               (click)="fileUpload.click()">
                 <mat-icon>attach_file</mat-icon>
             </button>
        </div> -->
        <div class="col-sm-3">
            <button id="addPolicyBtn" type="submit" [disabled]="!newFile" (click)="addPolicy()">Add Policy</button>
        </div>
    </div>
</form>
<hr>
<p>
    
    Policy List:
</p>
<form id="updatePolicyListForm" [formGroup]="updatePolicyListForm">
    <div class="row">
        <div class="col-sm-4">Select a category:
        </div>
        <div class="col-sm-4">
            <select id="selectedCategoryID" formControlName = "selectedCategoryID" (change)="changeCategory($event)">
                <option value="0">All</option>
                <option *ngFor="let category of categoryList" ngValue="{{category.categoryID}}">{{category.category}}</option>
            </select>
        </div>
    </div><br>
    <mat-table class="lessons-table mat-elevation-z8" [dataSource]="policyList">
        <ng-container matColumnDef="seqNo" matColumnDef="seqNo">
            <mat-header-cell *matHeaderCellDef="seqNo; sticky: true">Seq.</mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index">{{i + 1}}</mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef="category; sticky: true">Category</mat-header-cell>
            <mat-cell *matCellDef="let policy">{{policy.category}}</mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef="title; sticky: true">Title</mat-header-cell>
            <mat-cell class="title-cell" *matCellDef="let policy">
                <textarea id="title_{{policy.policyID}}" [disabled]="isDisabled" rows="2" cols="30">{{policy.title}}</textarea>
                <!-- <input id="title_{{policy.policyID}}" type="text" value="{{policy.title}}" [disabled]="isDisabled" matInput/> -->
            </mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="policyNumber" matColumnDef="policyNumber">
            <mat-header-cell *matHeaderCellDef="policyNumber; sticky: true">Policy Number</mat-header-cell>
            <mat-cell class="policyNumber-cell" *matCellDef="let policy">
                <input id="policyNumber_{{policy.policyID}}" type="text" value="{{policy.policyNumber}}" [disabled]="isDisabled" />
            </mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="policyNumberFormer" matColumnDef="policyNumberFormer">
            <mat-header-cell *matHeaderCellDef="policyNumberFormer; sticky: true">Former Policy Number</mat-header-cell>
            <mat-cell class="policyNumberFormer-cell" *matCellDef="let policy">
                <input id="policyNumberFormer_{{policy.policyID}}" type="text" value="{{policy.policyNumberFormer}}" [disabled]="isDisabled" />
            </mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="fileName">
            <mat-header-cell *matHeaderCellDef="fileName; sticky: true" style="width: 10%;">File Name</mat-header-cell>
            <mat-cell class="fileName-cell" *matCellDef="let policy">
                <!-- <a mat-button [routerLink]="['/policypdfviwer', policy.fileName]" target="_blank">{{policy.fileName}}</a> -->
                <a href="https://web01cdev.browardschools.local/bcpswebext/displaypdf.html?filename={{policy.fileName}}" target="_blank">{{policy.fileName}}</a>
                <!-- <input id="fileName_{{policy.policyID}}" type="text" value="{{policy.fileName}}" [disabled]="isDisabled" /> -->
            </mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="status" matColumnDef="status">
            <mat-header-cell *matHeaderCellDef="status; sticky: true" style="width: 5%;">Status</mat-header-cell>
            <mat-cell class="status-cell" *matCellDef="let policy">
                <lable id="lableStatus_{{policy.policyID}}">{{policy.active}}</lable>
                <select id="status_{{policy.policyID}}" style="visibility: hidden;">
                    <option>Active</option>
                    <option>Inactive</option>
                </select>
                <br>
                <label id="lablePolicyAdd" *ngIf="policy.addingPolicyStatus !== ''" >{{policy.addingPolicyStatus}}</label>
            </mat-cell>
        </ng-container>
    
        <ng-container matColumnDef="action" matColumnDef="action">
            <mat-header-cell *matHeaderCellDef="action; sticky: true">Action</mat-header-cell>
            <mat-cell class="action-cell" *matCellDef="let policy">
                <form id="updatePolicyForm" method="post" (ngSubmit)="UpdatePolicy()">
                    <input type="button" id="change_{{policy.policyID}}" value="Change" (click)="toggleText(policy.policyID, policy.active)">
                    <input type="button" id="update_{{policy.policyID}}" value="Update" (click)="updatePolicy(policy.policyID)" disabled>
                </form>
            </mat-cell>
        </ng-container>
    
        <mat-header-row *matHeaderRowDef="displayedColumns" style="color:darkgray; font: bold;"></mat-header-row>
    
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    
    </mat-table>
</form>
